import { render } from "./HandlesEdit.vue?vue&type=template&id=79db2b80"
import script from "./HandlesEdit.vue?vue&type=script&lang=js"
export * from "./HandlesEdit.vue?vue&type=script&lang=js"
script.render = render

export default script